import LoginRBIcon from './LoginRBIcon';
import LoginLTIcon from './LoginLTIcon';

const index = {
  'login-rb-icon': LoginRBIcon,
  'login-lt-icon': LoginLTIcon
};
export default index;
